import React from 'react'
import { motion } from 'framer-motion';
import ResumeCard from './ResumeCard';

const Education = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      {/* part one */}
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2010 - Runing</p>
          <h2 className="text-3xl md:text-4xl font-bold">Education Quality</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Secondary School Certificate"
            subTitle="Ratowal RN High School(2024 - Runing)"
            result="---"
            des="Secondary education or post-primary education covers two phases on the International Standard Classification of Education scale."
          />
          <ResumeCard
            title="Junior School Certificate"
            subTitle="Ratowal RN High School (2021 - 2022)"
            result="4.75/5"
            des="
            A good Junior School Certificate (JSC) student embodies academic excellence, demonstrating not only high grades but also a genuine passion for learning. "
          />
          <ResumeCard
            title="Primary School Certificate"
            subTitle="Ratowal RN High School (2018 - 2019)"
            result="5.00/5"
            des="
            An exemplary primary school student excels academically, showing enthusiasm for learning. They practice effective time management, possess a strong work ethic, and foster curiosity."
          />
        </div>
      </div>
      {/* part Two */}

      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2010 - 2022</p>
          <h2 className="text-3xl md:text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Digital Marketing"
            subTitle=" Fivver - (2019 - 2021)"
            result="Remote job"
            des="Google's hiring process is an important part of our culture. Googlers care deeply about their teams and the people who make them up."
          />
          <ResumeCard
            title="Professional Freelancer"
            subTitle="Freelance Marketplace - (2019 - Runing)"
            result="Freelance Marketplace"
            des="
            Experienced freelancer with a proven track record in content creation, digital marketing, and project management. Highly skilled in meeting tight deadlines, collaborating effectively, and delivering quality results."
          />
          <ResumeCard
            title="Front-end Developer"
            subTitle="JSM- (2020 - 2021)"
            result="Junior Devoloper"
            des="HTML, CSS, and JavaScript. Proven experience creating visually appealing and responsive websites. Adept at collaborating with cross-functional teams, meeting project deadlines, and implementing innovative design solutions."
          />
        </div>
      </div>
    </motion.div>
  );
}

export default Education